/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const StockTakeListService = {
  dataSourceConfig(url, params) {
    // var url = "api/StocktakeList";
    return ApiService.createDataSource(url, params);
  },
  async commitStockTake(payload) {
    const url = `api/Save_StocktakeCommit`;

    return await ApiService.post(url, payload);
  },
  async cancelStockTake(payload) {
    const url = `api/Save_StocktakeCancel`;

    return await ApiService.post(url, payload);
  },
};

export { StockTakeListService };
